import script from "./PortfolioSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioSection.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioSection.vue?vue&type=style&index=0&id=38ada311&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38ada311"]])

export default __exports__